"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceInfo = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Enums = require("../Common/Enums");

// Ported from https://dev.azure.com/dynamicscrm/OneCRM/_git/CRM.OmniChannel.LiveChatWidget?path=/src/LiveChatLoader/Utility/DeviceInfo.ts&version=GBrelease
var DeviceInfo = /*#__PURE__*/function () {
  function DeviceInfo() {
    (0, _classCallCheck2["default"])(this, DeviceInfo);
  }

  (0, _createClass2["default"])(DeviceInfo, null, [{
    key: "getDeviceType",
    value: function getDeviceType() {
      var mobile = /(android|ipod|windows phone|wpdesktop|windows ce|blackberry\w*|meego|webos|palm|symbian|pda|\w*?mobile\w*?|\w*?phone\w*?)/i;
      var tablet = /tablet|ipad/i;

      if (window.navigator.userAgent.match(mobile)) {
        return _Enums.DeviceType.Mobile;
      }

      if (window.navigator.userAgent.match(tablet)) {
        return _Enums.DeviceType.Tablet;
      }

      return _Enums.DeviceType.Desktop;
    }
  }]);
  return DeviceInfo;
}();

exports.DeviceInfo = DeviceInfo;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9VdGlscy9EZXZpY2VJbmZvLnRzIl0sIm5hbWVzIjpbIkRldmljZUluZm8iLCJtb2JpbGUiLCJ0YWJsZXQiLCJ3aW5kb3ciLCJuYXZpZ2F0b3IiLCJ1c2VyQWdlbnQiLCJtYXRjaCIsIkRldmljZVR5cGUiLCJNb2JpbGUiLCJUYWJsZXQiLCJEZXNrdG9wIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7O0FBRUE7SUFFYUEsVTs7Ozs7OztXQUNYLHlCQUFzQztBQUNwQyxVQUFNQyxNQUFNLEdBQUcsNEhBQWY7QUFDQSxVQUFNQyxNQUFNLEdBQUcsY0FBZjs7QUFFQSxVQUFJQyxNQUFNLENBQUNDLFNBQVAsQ0FBaUJDLFNBQWpCLENBQTJCQyxLQUEzQixDQUFpQ0wsTUFBakMsQ0FBSixFQUE4QztBQUM1QyxlQUFPTSxrQkFBV0MsTUFBbEI7QUFDRDs7QUFFRCxVQUFJTCxNQUFNLENBQUNDLFNBQVAsQ0FBaUJDLFNBQWpCLENBQTJCQyxLQUEzQixDQUFpQ0osTUFBakMsQ0FBSixFQUE4QztBQUM1QyxlQUFPSyxrQkFBV0UsTUFBbEI7QUFDRDs7QUFFRCxhQUFPRixrQkFBV0csT0FBbEI7QUFDRCIsInNvdXJjZVJvb3QiOiJvY3NkazovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBEZXZpY2VUeXBlIH0gZnJvbSBcIi4uL0NvbW1vbi9FbnVtc1wiO1xuXG4vLyBQb3J0ZWQgZnJvbSBodHRwczovL2Rldi5henVyZS5jb20vZHluYW1pY3Njcm0vT25lQ1JNL19naXQvQ1JNLk9tbmlDaGFubmVsLkxpdmVDaGF0V2lkZ2V0P3BhdGg9L3NyYy9MaXZlQ2hhdExvYWRlci9VdGlsaXR5L0RldmljZUluZm8udHMmdmVyc2lvbj1HQnJlbGVhc2VcblxuZXhwb3J0IGNsYXNzIERldmljZUluZm8ge1xuICBwdWJsaWMgc3RhdGljIGdldERldmljZVR5cGUoKTogc3RyaW5nIHtcbiAgICBjb25zdCBtb2JpbGUgPSAvKGFuZHJvaWR8aXBvZHx3aW5kb3dzIHBob25lfHdwZGVza3RvcHx3aW5kb3dzIGNlfGJsYWNrYmVycnlcXHcqfG1lZWdvfHdlYm9zfHBhbG18c3ltYmlhbnxwZGF8XFx3Kj9tb2JpbGVcXHcqP3xcXHcqP3Bob25lXFx3Kj8pL2k7XG4gICAgY29uc3QgdGFibGV0ID0gL3RhYmxldHxpcGFkL2k7XG5cbiAgICBpZiAod2luZG93Lm5hdmlnYXRvci51c2VyQWdlbnQubWF0Y2gobW9iaWxlKSkge1xuICAgICAgcmV0dXJuIERldmljZVR5cGUuTW9iaWxlO1xuICAgIH1cblxuICAgIGlmICh3aW5kb3cubmF2aWdhdG9yLnVzZXJBZ2VudC5tYXRjaCh0YWJsZXQpKSB7XG4gICAgICByZXR1cm4gRGV2aWNlVHlwZS5UYWJsZXQ7XG4gICAgfVxuXG4gICAgcmV0dXJuIERldmljZVR5cGUuRGVza3RvcDtcbiAgfVxufVxuIl19